<template>
  <div class="pa-2">
    <v-row>
      <!-- قیمت طلا -->
      <v-col cols="12" v-if="!valueComputed.cutie.text">
        <v-card-subtitle
          >برای دریافت قیمت ابتدا عیار طلا را مشخص کنید</v-card-subtitle
        >
      </v-col>

      <v-col cols="12">
        <v-card-title class="pa-0">
          سرویس دریافت قیمت طلا : {{ valueComputed.model.name ?? "رهاورد" }}
        </v-card-title>
        <v-card-subtitle class="pa-4 pr-0"
          >برای تعویض سرویس دریافت قیمت به قسمت دارایی ها مراجعه
          کنید</v-card-subtitle
        >
      </v-col>

      <!-- قیمت نهایی -->
      <v-col class="d-flex align-items-start" cols="12">
        <v-btn
          :loading="loading"
          elevation="0"
          color="rgb(191, 163, 13)"
          class="white--text mr-1"
        >
          طلا {{ valueComputed.cutie.text }} عیار:‌{{
            goldPrice.toLocaleString()
          }}
          ریال
        </v-btn>
        <price-input
          dense
          clearable
          :label="$t('final_product_price')"
          v-model="valueComputed.price.text"
          type="number"
          text-center="true"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.price.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.price.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- اسم سرکت -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.name"
          append-icon="mdi-domain"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint=" نام مجموعه خود را وارد کنید."
          label="نام مجموعه"
          maxlength="50"
          outlined
          class="contentinfo"
        />
      </v-col>

      <!-- اسم طلا -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.goldName"
          append-icon="mdi-basket"
          clear-icon="mdi-close-circle-outline"
          clearable
          counter="50"
          dense
          hint=" نام طلا خود را وارد کنید"
          label="نام محصول"
          maxlength="50"
          outlined
          class="contentinfo"
        />
      </v-col>

      <!-- وزن -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.weight.text"
          @change="payPrice('weight')"
          prepend-inner-icon="mdi-weight"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hint=" وزن طلا خود را وارد کنید"
          label="وزن طلا "
          type="number"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.weight.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.weight.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>

      <!-- عیار -->
      <v-col cols="12" md="6">
        <v-combobox
          v-model="valueComputed.cutie.text"
          :items="[24, 18]"
          dense
          hint=" عیار محصول خود را وارد کنید"
          label="عیار طلا "
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.cutie.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.weight.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <!-- مالیات -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.tax.text"
          prepend-inner-icon="mdi-sale"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          :hint="
            valueComputed.fee.value < 1 && valueComputed.wages.value < 1
              ? 'برای اعمال مالیات باید اجرت و کارمزد تعیین کنید'
              : 'مالیات را وارد کنید'
          "
          label="مالیات طلا  "
          persistent-hint
          type="number"
          :rules="[
            (v) =>
              (v <= 100 && v >= 0) ||
              'مقدار نمیتواند از ۱۰۰ بزرگتر و از ۰ کوچکتر باشد',
          ]"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.tax.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.tax.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>

      <!--  تخفیف -->
      <v-col cols="12" md="6">
        <v-text-field
          v-model="valueComputed.discount.text"
          prepend-inner-icon="mdi-cart-percent"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          label=" تخفیف  "
          type="number"
          :rules="[
            (v) =>
              (v <= 100 && v >= 0) ||
              'مقدار نمیتواند از ۱۰۰ بزرگتر و از ۰ کوچکتر باشد',
          ]"
          outlined
          class="contentinfo"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.discount.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.discount.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>

      <!-- اجرت ساخت -->
      <v-col cols="12" class="d-flex align-items-start justify-content-cenyter">
        <v-card
          style="height: 0"
          class="pa-0 d-flex align-items-center justify-content-center"
          flat
        >
          <v-radio-group
            style="height: 15px"
            v-model="valueComputed.wages.type"
            mandatory
          >
            <v-radio label="﷼" value="price"></v-radio>
            <v-radio label="درصد" value="percentage"></v-radio>
          </v-radio-group>
        </v-card>
        <price-input
          v-if="valueComputed.wages.type === 'price'"
          dense
          clearable
          label="اجرت ساخت"
          v-model="valueComputed.wages.value"
          type="number"
          text-center="true"
        >
          <template v-slot:append-outer> </template>
        </price-input>
        <v-text-field
          v-else
          v-model="valueComputed.wages.value"
          append-icon="mdi-sale"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hint="لطفا  درصد اجرت ساخت را وارد کنید."
          label="اجرت ساخت  "
          type="number"
          :rules="[
            (v) =>
              (v <= 100 && v >= 0) ||
              'مقدار نمیتواند از ۱۰۰ بزرگتر و از ۰ کوچکتر باشد',
          ]"
          outlined
          class="contentinfo"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.wages.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.wages.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- کارمزد فروشگاه -->
      <v-col cols="12" class="d-flex align-items-start justify-content-cenyter">
        <v-card
          style="height: 0"
          class="pa-0 d-flex align-items-center justify-content-center"
          flat
        >
          <v-radio-group
            style="height: 15px"
            v-model="valueComputed.fee.type"
            mandatory
          >
            <v-radio label="﷼" value="price"></v-radio>
            <v-radio label="درصد" value="percentage"></v-radio>
          </v-radio-group>
        </v-card>
        <price-input
          v-if="valueComputed.fee.type === 'price'"
          dense
          clearable
          label="کارمزد فروشنده "
          v-model="valueComputed.fee.value"
          type="number"
          text-center="true"
        >
          <template v-slot:append-outer> </template>
        </price-input>
        <v-text-field
          v-else
          v-model="valueComputed.fee.value"
          prepend-inner-icon="mdi-sale"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hint="لطفا  درصد  کارمزد فروشنده را وارد کنید."
          label="کارمزد فروشنده   "
          type="number"
          :rules="[
            (v) =>
              (v <= 100 && v >= 0) ||
              'مقدار نمیتواند از ۱۰۰ بزرگتر و از ۰ کوچکتر باشد',
          ]"
          outlined
          class="contentinfo"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.fee.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.fee.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- تاریخ ساخت -->
      <v-col cols="12" class="d-flex justify-content-center align-items-start">
        <custom-date-picker
          v-model="valueComputed.create_at.text"
          type="date"
          label="زمان ساخت"
          outlined
          input-class="date-end"
          dense
          append-icon="mdi-calendar-month"
        />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex align-center"
              v-on="on"
              v-bind="attrs"
              style="cursor: pointer"
            >
              <v-checkbox
                v-model="valueComputed.create_at.line"
                hide-details
                class="ma-0 pa-0"
                dense
                style="height: 20px; width: 20px"
                @click.stop
              ></v-checkbox>
            </div>
          </template>
          <span>
            {{
              valueComputed.create_at.line
                ? "خط جداکننده غیر فعال شود"
                : "خط جدا کننده فعال شود"
            }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- درباره محصول -->
      <v-col cols="12">
        <suggest-text-gold
          v-model="valueComputed.discriptions.text"
          label="درباره طلا"
          :prompt="valueComputed.goldName || valueComputed.name"
          :counter="2000"
          :rows="5"
          hint="لطفا توضیحات محصول خود را وارد کنید."
        >
          <template v-slot:append-line>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center mt-1"
                  v-on="on"
                  v-bind="attrs"
                  style="cursor: pointer"
                >
                  <v-checkbox
                    v-model="valueComputed.discriptions.line"
                    hide-details
                    class="ma-0 pa-0"
                    dense
                    style="height: 20px; width: 20px"
                    @click.stop
                  ></v-checkbox>
                </div>
              </template>
              <span>
                {{
                  valueComputed.discriptions.line
                    ? "خط جداکننده غیر فعال شود"
                    : "خط جدا کننده فعال شود"
                }}
              </span>
            </v-tooltip>
          </template>
        </suggest-text-gold>
      </v-col>
    </v-row>

    <v-card-title> اطلاعات بیشتر خود را وارد کنید </v-card-title>

    <extra-fields-gold v-model="value.more" block />
  </div>
</template>

<script>
import customDatePicker from "../../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import SuggestTextGold from "../../../components/SuggestBox/suggestTextGold.vue";
import priceInput from "../../uiBeautifier/priceInput.vue";
import extraFieldsGold from "./extraFieldsGold.vue";

export default {
  name: "factoryGoldLabel",

  components: {
    customDatePicker,
    priceInput,
    extraFieldsGold,
    SuggestTextGold
  },

  props: {
    value: {},
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "factory-info",
      wagesType: [
        { text: "درصد", value: "percentage", line: false },
        { text: "ریال", value: "price", line: false },
      ],
      goldPrice: "",
      loading: false,
    };
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    valueComputed: {
      deep: true,
      immediate: true,
      handler(val) {},
    },
    "valueComputed.model.source": {
      deep: true,
      immediate: true,
      handler(val) {
        this.getPrice(this.valueComputed.model.value);
      },
    },
    "valueComputed.cutie.text"(val) {
      if (val == 24) {
        this.getPrice(this.valueComputed.model.value);
      } else if (val == 18) {
        this.getPrice(this.valueComputed.model.value);
      }
    },
    "valueComputed.weight.text"(val) {
      this.payPrice();
    },
    "valueComputed.wages.value"(val) {
      this.payPrice();
    },
    "valueComputed.fee.value"(val) {
      this.payPrice();
    },
    "valueComputed.tax.text"(val) {
      this.payPrice();
    },
    "valueComputed.discount.text"(val) {
      this.payPrice();
    },
  },

  mounted() {
    this.getPrice(this.valueComputed.model.value);
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    async getPrice(url) {
      this.loading = true;
      let datas = [];
      try {
        await this.$api
          .get(
            url,
            {
              params: {
                type: "gold",
                length: "1000",
                source: this.value.model.source ?? null,
              },
            },

            {
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*",
              "Content-Type": "application/json",
            }
          )
          .then(({ data }) => {
            console.log(data.data.data);

            datas = data.data.data;
          });
        if (this.value.cutie.text == 24) {
          this.goldPrice = datas.find(
            (item) =>
              /(۲۴|24)\s*عیار/.test(item.name) && !/خرید/.test(item.name)
          ).close_price;
        } else if (this.value.cutie.text == 18) {
          this.goldPrice = datas.find(
            (item) =>
              /(۱۸|18)\s*عیار/.test(item.name) && !/خرید/.test(item.name)
          ).close_price;
        }
      } catch (err) {
        // this.getPrice(url);
      } finally {
        this.loading = false;
        this.payPrice();
      }
    },
    payPrice() {
      const weight = Number(this.valueComputed?.weight?.text) || 0;
      const wagesValue = Number(this.valueComputed?.wages?.value) || 0;
      const feeValue = Number(this.valueComputed?.fee?.value) || 0;
      const taxPercent = Number(this.valueComputed?.tax?.text) || 0;
      const discountPercent = Number(this.valueComputed?.discount?.text) || 0;
      const goldPrice = Number(this.goldPrice) || 0;

      // اجرت
      const wages =
        this.valueComputed.wages.type === "percentage"
          ? goldPrice * wagesValue * 0.01
          : wagesValue * weight;

      // کارمزد
      const fee =
        this.valueComputed.fee.type === "percentage"
          ? goldPrice * feeValue * 0.01
          : feeValue * weight;

      const taxBase = wages + fee;
      const tax = taxBase * taxPercent * 0.01;

      const price = goldPrice * weight + wages + fee + tax;

      const priceDiscount = price - price * discountPercent * 0.01;

      const finalPrice = Math.round(
        discountPercent > 0 ? priceDiscount : price
      );
      console.log("Before:", goldPrice);
      this.$set(this.valueComputed, "price", {
        text: Math.round(finalPrice),
        line: this.valueComputed?.price?.line || "",
      });
      console.log("After:", this.valueComputed.price);
    },
  },
};
</script>

<style scoped></style>
